import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UnsubscribeHelper {
  public unsubscribe(subscriptions: Subscription[]): void {
    for (let i = 0; i < subscriptions.length; i++) {
      subscriptions[i]?.unsubscribe();
    }
  }
}
